import { authState } from '../../lib/auth.js';
import { BaseComponent } from '../../lib/base-component.js';
import { navigateAfterSignIn } from '../../lib/pending-oauth.js';
import { css, html } from '../../vendor/lit.min.js';
import '../login-form.js';

class LoginView extends BaseComponent {
    static styles = css`
        :host { display: block; }
        .login-card { max-width: 420px; margin: 0 auto; }
    `;

    _onAuthenticated() {
        navigateAfterSignIn(sessionStorage, authState.consentsOutstanding);
    }

    render() {
        return html`
            <div class="login-card mt-5">
                <div class="card shadow">
                    <div class="card-body p-4">
                        <h3 class="card-title text-center mb-4">Sign In</h3>

                        ${authState.sessionExpired ? html`<div class="alert alert-warning">Your session has expired. Please sign in again.</div>` : ''}

                        <login-form @authenticated="${this._onAuthenticated}"></login-form>
                    </div>
                </div>
                <div class="text-center mt-3">
                    <small class="text-muted">
                        <a href="/terms" class="text-decoration-none">Terms of Service</a>
                        <span class="mx-2">|</span>
                        <a href="/privacy" class="text-decoration-none">Privacy Policy</a>
                    </small>
                </div>
            </div>
        `;
    }
}

customElements.define('login-view', LoginView);
export { LoginView };
